export function routes($stateProvider) {
  $stateProvider
    .state('app.projeto', {
      url: '/projeto',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.projeto.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Projetos',
      template: require('./directory/directory.view.html'),
      controller: 'ProjetoListController',
      controllerAs: 'vm',
      role: 'projetoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.projeto.details', {
      url: '/{id}',
      title: 'Projeto',
      controller: 'ProjetoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'projetoRead'
    })
    .state('app.projeto.new', {
      url: '/novo',
      title: 'Adicionar Projeto',
      template: require('./new/new.view.html'),
      controller: 'ProjetoCreateProjetoController',
      controllerAs: 'vm',
      role: 'projetoCreate'
    })
    .state('app.projeto.new.1', {
      template: require('./new/projeto.1.form.html')
    })
    .state('app.projeto.new.2', {
      template: require('./new/projeto.2.form.html')
    })
    .state('app.projeto.new.3', {
      template: require('./new/projeto.3.form.html')
    })
    .state('app.projeto.new.4', {
      template: require('./new/projeto.4.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
